// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateAthenaPatientPopup-module__container___LW9z7 {
  padding: 25px 30px;
}

.CreateAthenaPatientPopup-module__buttonsContainer___RM5ic {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}

.CreateAthenaPatientPopup-module__processingStatus___Ik0OI {
  padding: 12px 16px;
  background-color: #f0f7ff;
  border-radius: 6px;
  color: #1a73e8;
  font-size: 14px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/popups/CreateAthenaPatientPopup/CreateAthenaPatientPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  padding: 25px 30px;\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n\n.processingStatus {\n  padding: 12px 16px;\n  background-color: #f0f7ff;\n  border-radius: 6px;\n  color: #1a73e8;\n  font-size: 14px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CreateAthenaPatientPopup-module__container___LW9z7`,
	"buttonsContainer": `CreateAthenaPatientPopup-module__buttonsContainer___RM5ic`,
	"processingStatus": `CreateAthenaPatientPopup-module__processingStatus___Ik0OI`
};
module.exports = ___CSS_LOADER_EXPORT___;
